/**
 * @type {string}
 */
const UserAgent = navigator.userAgent || navigator.vendor || window.opera;

/**
 * @type {boolean}
 */
const WindowsPhone = /Windows Phone/i.test(UserAgent);

/**
 * Windows Phone includes `Android` in it's user agent string
 * so we have to make sure it's not a windows phone. See:
 * https://stackoverflow.com/questions/21741841/detecting-ios-android-operating-system
 *
 * @type {boolean}
 */
const Android = WindowsPhone === false && /Android|mobile-native-android/i.test(UserAgent);

/**
 * Microsoft included `iPhone` in the user agent of
 * Internet Explorer 11 so we check for `MSStream`.
 * See: https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
 *
 * @type {boolean}
 */
const iOS = /iPad|iPhone|iPod|mobile-native-ios/.test(UserAgent) && !window.MSStream;

/**
 * Only the web view of our iOS app, not Safari on an iPhone like `iOS` above.
 * The app appends `mobile-native-ios` to the user agent. It sets the user agent
 * asynchronously, so its console bridge, which runs before any page script, is
 * checked as well.
 *
 * @type {boolean}
 */
// eslint-disable-next-line no-underscore-dangle
const iOSApp = /mobile-native-ios/.test(UserAgent) || window.__iosConsoleBridgeInstalled === true;

/**
 * @type {boolean}
 */
const Mobile = WindowsPhone || Android || iOS;

/**
 * @type {boolean}
 */
const inFileContext = window.location.protocol === 'file:';

/**
 * When there is a default request bridge we can
 * assume an app is running this script.
 * @type {boolean}
 */
const App = Boolean(window.SourceApp === 'iOS' || window.SourceApp === 'Android');

export {
    Android,
    iOS,
    iOSApp,
    WindowsPhone,
    Mobile,
    App,
    inFileContext,
};



// WEBPACK FOOTER //
// ./scripts/utils/mobileDetection.js